import React from 'react';
import { FileText } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useApp } from '../../context/AppContext';

const AlgemeneVoorwaardenPage = () => {
  const { t } = useApp();
  
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-2">{t('terms_title')}</h1>
        <p className="text-[#A8A29E] mb-8">{t('terms_last_updated')}</p>

        <div className="max-w-4xl glass rounded-xl p-6 md:p-8 space-y-8">
          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_1')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>{t('terms_definitions_intro')}</p>
              <p><strong className="text-white">{t('terms_entrepreneur')}:</strong> {t('terms_entrepreneur_desc')}</p>
              <p><strong className="text-white">{t('terms_consumer')}:</strong> {t('terms_consumer_desc')}</p>
              <p><strong className="text-white">{t('terms_distance_contract')}:</strong> {t('terms_distance_contract_desc')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_2')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>ZuiverParfum</p>
              <p>{t('terms_email')}: info@zuiverparfum.nl</p>
              <p>{t('terms_kvk')}: [{t('terms_to_be_filled')}]</p>
              <p>{t('terms_btw')}: [{t('terms_to_be_filled')}]</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_3')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_applicability_1')}</p>
              <p>2. {t('terms_applicability_2')}</p>
              <p>3. {t('terms_applicability_3')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_4')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_offer_1')}</p>
              <p>2. {t('terms_offer_2')}</p>
              <p>3. {t('terms_offer_3')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_5')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_agreement_1')}</p>
              <p>2. {t('terms_agreement_2')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_6')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_withdrawal_1')}</p>
              <p>2. {t('terms_withdrawal_2')}</p>
              <p>3. {t('terms_withdrawal_3')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_7')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_prices_1')}</p>
              <p>2. {t('terms_prices_2')}</p>
              <p>3. {t('terms_prices_3')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_8')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_delivery_1')}</p>
              <p>2. {t('terms_delivery_2')}</p>
              <p>3. {t('terms_delivery_3')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_9')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>1. {t('terms_complaints_1')}</p>
              <p>2. {t('terms_complaints_2')}</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">{t('terms_article_10')}</h2>
            <div className="text-[#A8A29E] space-y-2 text-sm leading-relaxed">
              <p>{t('terms_applicable_law')}</p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default AlgemeneVoorwaardenPage;
